/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./add-resource-button.vue?vue&type=template&id=681b41ca&"
import script from "./add-resource-button.vue?vue&type=script&lang=js&"
export * from "./add-resource-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports